import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=62f6ee9a&lang=pug&"
import script from "./Shop.vue?vue&type=script&lang=js&"
export * from "./Shop.vue?vue&type=script&lang=js&"
import style0 from "./Shop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f6ee9a')) {
      api.createRecord('62f6ee9a', component.options)
    } else {
      api.reload('62f6ee9a', component.options)
    }
    module.hot.accept("./Shop.vue?vue&type=template&id=62f6ee9a&lang=pug&", function () {
      api.rerender('62f6ee9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Shop.vue"
export default component.exports